import singleEntity from 'base/reducers/singleEntity';

import { MENU as ENTITY } from 'menus/constants/entities';

const apiReducer = singleEntity(ENTITY);

export default apiReducer;

export { default as menuItemsDetail } from 'menus/reducers/menuItemsDetail';
export { default as productPreview } from 'menus/reducers/productPreview';
